import {useState, useContext} from 'react';
import {UserContext, UpdateUserContext} from "../../App"
import {Choisir} from "./Choisir"
import {Modal} from "../question/Modal"
import {clean, color_note, affiche_param} from "../Fonctions"
import {tab_color_bg, tab_color_btn} from "../config/Config"

import './Devoirs.css';

export function Devoirs_alea ({auth, updateUser}) {

  const {currentUser} = useContext(UserContext)
  const user = currentUser
  const updateUsercontext = useContext(UpdateUserContext)
  const [show_activite, setShow_activite] = useState(false)
  
  // Dates
  const dat = new Date()
  const dat_month = dat.getMonth()+1 < 10 ? '0'+ (dat.getMonth()+1) : dat.getMonth()+1
  const dat_day = dat.getDate() < 10 ? '0'+ (dat.getDate()) : dat.getDate()
  const today = dat.getFullYear() + '-' + dat_month + '-' + dat_day
  const cleanDate = (date) => date.slice(-2)+'/'+date.slice(-5,-3)

  const [devoir_cree, setDevoir_cree] = useState({
    classe:user.liste_classes[0],
    nb_question:'3',
    etoile:'',
    niveau:'',
    titre:'',
    titre_active:false,
    comm_active:'',
    info_diff:false,
    champ_valid:true,
    optionnel:'Non',
    date_limit:'Non',
    date_limit_value:today,
    notion:[],
    selection:{},
    search:'',
    config_supp:'',
    config_supp_active:false,
    mode_aleatoire:true,
  })
  const cleanDevoir_cree = (param) => {
    setDevoir_cree({...devoir_cree, titre:'', titre_active:false, comm_active:'', niveau:'', nb_question:'3', etoile:'', notion:[], selection:{}, config_supp_active:param === 'supprMesquestions'})
  }
  
  const [diff, setDiff] = useState({
    niv1:user.diff.niv1,
    niv2:user.diff.niv2,
    niv3:user.diff.niv3
  })
  const [msg, setMsg] = useState({
    diff_maj:'',
    suppr_devoir:'',
  })

  const cleanMsg = (name) => {
    setTimeout(e => {
          setMsg({...msg, [name]:''})
        }, 3000)
  }

  const handleChange = (e) => {
    const name = e.target.attributes.name.nodeValue
    //setDevoir_cree({...devoir_cree, [name]:e.target.value})
    if(devoir_cree.titre.includes('&')||devoir_cree.titre.includes('\\')||devoir_cree.titre.includes('<')||devoir_cree.titre.includes('>')||devoir_cree.titre.includes('"') 
      || devoir_cree.comm_active.includes('&')||devoir_cree.comm_active.includes('\\')||devoir_cree.comm_active.includes('<')||devoir_cree.comm_active.includes('>')||devoir_cree.comm_active.includes('"')
      ||e.target.value.includes('&')||e.target.value.includes('\\')||e.target.value.includes('<')||e.target.value.includes('>')||e.target.value.includes('"')){
      setMsg({alert_titre:'<div class="alert danger"><br>Vous ne pouvez pas utiliser de caractères <br> spéciaux tels que &, \\, \', <, > ou " !<br><br></div>'})
      setDevoir_cree({...devoir_cree, [name]:e.target.value, champ_valid:false})
    } else {
      setMsg({alert_titre:''})
      setDevoir_cree({...devoir_cree, [name]:e.target.value, champ_valid:true})
    }
  }

  const handleClick = (e) => {
    let name = e.target.attributes.name.nodeValue
    let field = name === 'date_limit_value' ? e.target.value : e.target.innerText
    
    if (field === 'Oui' && 'optionnel_date_limit'.includes(name)) {field = 'Non'}
    else if (field === 'Non' && 'optionnel_date_limit'.includes(name)) {field = 'Oui'}
    if (name === 'etoile' && field === devoir_cree.etoile) {field=''}
    if(e.target.className.includes('btn_param') ||'date_limit_value_etoile_soustitre_config_supp'.includes(name)) {
      setDevoir_cree({...devoir_cree, [name]:field})
    }
    if(name === 'config_supp_active'){
      if(devoir_cree.config_supp_active){
        field = false
        e.target.innerText = '+'
      } else {
        field = true
        e.target.innerText = '−'
      }
      setDevoir_cree({...devoir_cree, config_supp:'Choisir des questions', [name]:field})
    }
    if(name === 'niveau'){
      setDevoir_cree({...devoir_cree, search:'', niveau:(devoir_cree.niveau !== field.trim()) && field.trim(), selection:{}})
    }
    if(name==="modif_titre") {setDevoir_cree({...devoir_cree, titre_active:true})}
    if(name==="info_diff") {setDevoir_cree({...devoir_cree, info_diff:!devoir_cree.info_diff})}
    if(name==="mode_aleatoire") {setDevoir_cree({...devoir_cree, mode_aleatoire:!devoir_cree.mode_aleatoire})}
    if(e.target.className === 'teal'){
      e.target.className = 'chocolate'
      setDiff({...diff, niv1:diff.niv1?.replace(e.target.id+'__', ''), niv2:diff.niv2+e.target.id+'__'})
    }
    else if(e.target.className === 'chocolate'){
      e.target.className = 'purple'
      setDiff({...diff, niv2:diff.niv2?.replace(e.target.id+'__', ''), niv3:diff.niv3+e.target.id+'__'})
    }
    else if(e.target.className === 'purple'){
      e.target.className = 'teal'
      setDiff({...diff, niv3:diff.niv3?.replace(e.target.id+'__', ''), niv1:diff.niv1+e.target.id+'__'})
    }
  }

  const handleClickTitre = (e) => {
    let field = e.target.innerText
    let selection = {}
    let tab_notion = devoir_cree.notion
    
    if(!e.target.title){
      if(devoir_cree.selection[field] && devoir_cree.selection[field].length === 0){
        selection = devoir_cree.selection
        delete selection[field]
        tab_notion = tab_notion.filter(elt => elt !== field)
        setDevoir_cree({...devoir_cree, selection, config_supp:'', mode_aleatoire:true, notion:tab_notion})
      } else {
        selection = {...devoir_cree.selection, [field]:[]}
        tab_notion = tab_notion.filter(elt => !elt.includes(field) )
        tab_notion.push(field)
        setDevoir_cree({...devoir_cree, selection, config_supp:'', mode_aleatoire:true, notion:tab_notion})
      }
    } else {
      const titre = e.target.title.split('/')[0]
      tab_notion = tab_notion.filter(elt=> elt != titre)
      //const soustitre = e.target.title.split('/')[1]

      if(!devoir_cree.selection[titre]) {
        const selection = {...devoir_cree.selection, [titre]:[field]}
        tab_notion.push(e.target.title)
        setDevoir_cree({...devoir_cree, selection, config_supp:'', mode_aleatoire:true, notion:tab_notion})
      } else {
        const tab = devoir_cree.selection[titre]

        if(!tab.includes(field)){
          tab.push(field)
          tab_notion.push(e.target.title)
          const selection = {...devoir_cree.selection, [titre]:tab}
          setDevoir_cree({...devoir_cree, selection, config_supp:'', mode_aleatoire:true, notion:tab_notion})
        }
        else {
          tab_notion = tab_notion.filter(elt =>elt!==e.target.title)
          const index = tab.indexOf(field)
          tab.splice(index, 1)
          if(tab.length === 0){
            selection = devoir_cree.selection
            delete selection[titre]
          } else {
            selection = {...devoir_cree.selection, [titre]:tab}
          }
          setDevoir_cree({...devoir_cree, selection, config_supp:'', mode_aleatoire:true, notion:tab_notion})
          
        }
      }
    }
  }

  const sendData = (auth, name) => {
    fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
      method: 'POST',
      body: JSON.stringify(auth)
    })
    .then(response => response.json())
    .then(data => {
      setMsg({...msg, [name]:data})
      cleanMsg(name)
      updateUsercontext()
      //updateUser()
      cleanDevoir_cree()
    })
    .catch(err => console.log(err))
  }
  const joinObj = (obj) => {
    let result = ''
    Object.keys(obj).map(e => {
      result += devoir_cree.selection[e]?.length > 0 ? (devoir_cree.selection[e]?.length === 1 ? '__'+e+'/'+devoir_cree.selection[e] : '__'+e+'/'+devoir_cree.selection[e].join('__'+e+'/')) : (result ? '__'+e : e)
    })
    if(result.slice(-2) === '__') {result = result.slice(0,-2)}
    if(result.slice(0,2) === '__') {result = result.slice(2,result.length)}
    return result
  }
  const handleSubmit = (e) => {
    const name = e.target.attributes.name.nodeValue
    if (!devoir_cree.champ_valid){
      setMsg({devoir_send:'<div class="alert danger"><br>Le devoir n\'a pas été envoyé.<br>Le titre (ou la consigne) n\'est pas valide...<br><br></div>'})
      return
    }
    switch (name) {
      case 'suppr_devoir':
        let confirm = window.confirm("Voulez-vous vraiment supprimer la demande de faire ce devoir ?");
        if (!confirm) {return}
        auth = {...auth, action:name, field:e.target.id}
        sendData(auth, name)
        break;
      case 'diff_maj':
        if(!diff.niv1 && !diff.niv2 && ! diff.niv3) {
          setMsg({...msg,action:name, diff_maj:'<div class="alert danger fadeout5"><br>Veuillez modifier au moins un niveau d\'élève. <br><br>'})
          cleanMsg('diff_maj')
        } else {
            auth = {...auth, action:name, field:[diff.niv1, diff.niv2, diff.niv3], diff_sql:user.diff}
            sendData(auth, name)
        }
        break;
      case 'devoir_send':
        auth = {...auth, action:name, field:[devoir_cree.niveau, devoir_cree.nb_question, devoir_cree.etoile==='' ? '0' : devoir_cree.etoile , joinObj(devoir_cree.selection) , devoir_cree.classe, devoir_cree.optionnel==='Non', devoir_cree.titre, devoir_cree.date_limit==='Oui' ? devoir_cree.date_limit_value:'', devoir_cree.comm_active]}
        sendData(auth, name)
        break;
      default:
        console.log('default')
    }
  }
  const moyenne = (eleves) => {
    let moy = 0
    let nb_question = 0
    eleves?.forEach(e => {
      moy = moy + e.note*e.nb_question
      nb_question = nb_question + e.nb_question*1
    })
    return Math.round(moy*10/nb_question)/10
  }
  const diff_niv = (eleve) => {
    if (user.diff?.niv2?.includes(eleve.id)) {return "chocolate"}
    if (user.diff?.niv3?.includes(eleve.id)) {return "purple"}
    else {return "teal"}
  }

  let color_devoir = {}
  let color_btn = {}


  let k = 0
  user.liste_classes?.forEach(c => {
    color_devoir = {...color_devoir, [c]:tab_color_bg[k]}
    color_btn = {...color_btn, [c]:tab_color_btn[k]}
    k++
  })

  /*if (user.statut !== 'admin_314159') {
    const dev2 = '2e devoir mêmes notions'
    const dev3 = '3e devoir mêmes notions'
    Object.keys(user.liste_activites_all).map(e => {
      delete user.liste_activites_all[e][dev2]
      delete user.liste_activites_all[e][dev3]
    })
  }*/
  //console.log(user)
  //console.log(devoir_cree.notion)
  //console.log(devoir_cree.selection)
  return (
    <div>
      {user.liste_classes.length ?
      <>
    	<div id="creer" className="content max" style={{textAlign:"left"}} >
       <h1>Donner un devoir</h1>
      <div name="notions">
      {Object.keys(user.liste_activites_all).map((activites, k) => 
          <div key={k} className={devoir_cree.niveau === activites ? 'cadre_notion active' : 'cadre_notion'} >
            <span className="niveau" name="niveau" onClick={handleClick} > {activites} </span> 
            {devoir_cree.niveau === activites ? <input name="search" type="text" className="recherche_rapide" placeholder="Recherche rapide" onChange={handleChange} /> :''}
            
            <br/>
            <div className={'cadre_liste_notion' + (devoir_cree.search && ' col1')} >
              {Object.keys(user.liste_activites_all[activites]).map((titre, kt) => 
                <span key={kt}>
                  {clean(titre).includes(clean(devoir_cree.search)) && <div>
                                      <b name="titre" className={'devoir_titre'+(Object.keys(devoir_cree.selection).includes(titre) && (devoir_cree.selection[titre] && devoir_cree.selection[titre].length === 0) ? ' active' :'')} onClick={handleClickTitre}>{titre}</b>
                                    </div>}
                  {Object.values(user.liste_activites_all[activites][titre]).map((soustitre,ks) => 
                      (clean(titre).includes(clean(devoir_cree.search)) || clean(soustitre).includes(clean(devoir_cree.search))) && <div key={ks} title={titre+'/'+soustitre} name="soustitre" className={'devoir_titre'+(devoir_cree.selection[titre]?.includes(soustitre) ? ' active' :'')} onClick={handleClickTitre} >{ soustitre }
                        </div>
                    )}
                  {(clean(titre).includes(clean(devoir_cree.search))) && <br/>}
                </span>
              )}
            </div>
          </div>
        )}
      </div>
      <br/>
       Choisir une classe : {affiche_param(user.liste_classes, devoir_cree.classe, 'classe', handleClick)}

       {
        /* ======= Est remplacé par la fonction affiche_classe =======        
        user.liste_classes?.map((classe, k) => 
        <span key={k} className={'btn_param'+(devoir_cree.classe === classe ? ' active' : '') } name="classe" onClick={handleClick} >{classe}</span>)*/
      }
       <br/>
       Choisir un mode pour le devoir : {/*affiche_param(['Questions aléatoires', 'Questions choisies'], devoir_cree.mode_aleatoire, 'mode_aleatoire', handleClick)*/}
       <span className={'btn_param' + (devoir_cree.mode_aleatoire ? ' active' : '')} name="mode_aleatoire" onClick={handleClick}>Questions aléatoires</span>
       <span className={'btn_param' + (!devoir_cree.mode_aleatoire ? ' active' : '')} name="mode_aleatoire" onClick={handleClick}>Questions choisies</span>
       <br/>
       {
        devoir_cree.mode_aleatoire && <span>
          
       Nombre de question : {affiche_param(['3', '5', '10'], devoir_cree.nb_question, 'nb_question', handleClick)}

       {
        /*======= Est remplacé par la fonction affiche_classe ======= 
        ['3', '5', '10'].map(nb => 
          <span key={nb} className={'btn_param'+(devoir_cree.nb_question === nb ? ' active' :'')} name="nb_question" onClick={handleClick}>{nb}</span>
          )*/
        }

       <br/>
       Difficulté : {affiche_param(['⭐', '⭐⭐', '⭐⭐⭐', '🅳'], devoir_cree.etoile, 'etoile', handleClick)}

      {
        /*['⭐', '⭐⭐', '⭐⭐⭐'].map(niv => 
        <span key={niv} className={'btn_param'+(devoir_cree.etoile === niv ? ' active' :'')} name="etoile" onClick={handleClick}>{niv}</span>
        )*/
      }
       <br/>
        </span>
       }
       <span title={"Un devoir optionnel n'amène pas le score de 0 % lorsque l'élève ne le réalise pas et que de le(la) professeur supprime la demande de faire ce devoir.  \u000dCette option permet de différentier en quantité, mais peut aussi être utilisée pour différentier les devoirs par notions."}>Devoir optionnel ? <span className={'btn_param' + (devoir_cree.optionnel === 'Oui' ? ' active' : '')} name="optionnel" onClick={handleClick}>{devoir_cree.optionnel}</span></span>
       <br/>
       Indiquer une date limite ?  <span className="btn_param" name="date_limit" onClick={handleClick}>{devoir_cree.date_limit}</span>
       {devoir_cree.date_limit === 'Oui' ? <input type="date" name="date_limit_value" value={devoir_cree.date_limit_value} min={today} onClick={handleClick} onChange={handleChange} /> : ''}

      <br/>
        <div id="selection" className="cadre_selection" align="center">
          <div align="left" className="message resultat" style={{backgroundColor:color_devoir[devoir_cree.classe]}} >
            {devoir_cree.notion.length && devoir_cree.mode_aleatoire ? <div className="eye" title="Voir un exemple de devoir aléatoire" onClick={()=>setShow_activite(true)}>👁</div> : ''}
            <div className="info_mess">{cleanDate(today)}<br/>
            {devoir_cree.date_limit === 'Oui' ? <span className="date_limit_arrow">{cleanDate(devoir_cree.date_limit_value)}</span> : ''}</div> 
            {devoir_cree.optionnel === 'Oui' ? <div className="facultatif_mark" title="Devoir optionnel"></div> : ''}
            <div className="note_serie">{devoir_cree.classe}</div> <div className="nb_question">{devoir_cree.nb_question}Q</div> {devoir_cree.etoile === '🅳' ? <span style={{color:"steelblue", fontWeight:"bold"}} >🅳</span> : devoir_cree.etoile}
            <br/>

              {Object.keys(devoir_cree.selection).length ? 
                  <span title="Modifier le titre de ce devoir ou ajouter une consigne." name="modif_titre" className="modif_titre" onClick={handleClick}>🖊</span>
               : ''}

              <input type="text" name="titre" className={devoir_cree.titre_active && Object.keys(devoir_cree.selection).length ? 'active' : ''} placeholder="Titre du devoir (facultatif)" onChange={handleChange} value={devoir_cree.titre} />
              {msg.alert_titre ? <span dangerouslySetInnerHTML={{ __html:msg.alert_titre}}></span> : ''}
              <textarea rows="2" maxLength="120" name="comm_active" className={devoir_cree.titre_active && Object.keys(devoir_cree.selection).length ? 'active' : ''} placeholder="Ajouter une consigne (facultatif)" onChange={handleChange} value={devoir_cree.comm_active} />
              <div>
                {Object.keys(devoir_cree.selection).map((titre, k) => <span key={k}>{devoir_cree.selection[titre][0] ? devoir_cree.selection[titre].map((soustitre, k2)=><span key={k2}>{titre}/{soustitre}<br/></span>) : titre }{!devoir_cree.selection[titre][0] ? <br/> : ''}</span>)}
              </div>
              {Object.keys(devoir_cree.selection).length && devoir_cree.mode_aleatoire ? 
                <div align="center"><br/>
                  <input className="btn standard" name="devoir_send" type="button" value="Envoyer" onClick={handleSubmit} style={{backgroundColor: color_devoir[devoir_cree.classe], color:color_btn[devoir_cree.classe], border:'2px solid '+color_btn[devoir_cree.classe]}} />
                </div> : ''}
          </div>
          {msg.devoir_send ? <span dangerouslySetInnerHTML={{ __html:msg.devoir_send}}></span> : ''}
        </div>
        <span id="choisir0"></span>
      </div>
      

      {
        Object.keys(devoir_cree.selection).length && !devoir_cree.mode_aleatoire ? <div className="content max" style={{textAlign:"left", minHeight:'150px'}} >
        <Choisir auth={{...auth, classe:devoir_cree.classe, notions:joinObj(devoir_cree.selection), titre:devoir_cree.titre, consigne:devoir_cree.comm_active, date_limit:devoir_cree.date_limit === 'Oui' ? devoir_cree.date_limit_value : false, facultatif:devoir_cree.optionnel,nb_question:devoir_cree.nb_question, etoile:devoir_cree.etoile}} selection={devoir_cree.selection} niveau={devoir_cree.niveau} msg={msg} setMsg={setMsg} cleanMsg={cleanMsg} updateUser={updateUser} cleanDevoir_cree={cleanDevoir_cree} />
        </div> :''
      }


      <div id="liste_devoirs" className="content" style={{textAlign:"left", minHeight:'150px'}} >
        <h1>Mes devoirs en cours ({devoir_cree.classe})</h1>
        {msg.suppr_devoir ? <span dangerouslySetInnerHTML={{ __html:msg.suppr_devoir}}></span> : ''}
        <div >
         {user.mes_devoirs.map((devoir, k) => 
            (devoir.classe === devoir_cree.classe) &&
            <div key ={k} className="message resultat" title={devoir.activite.replaceAll('__', '\u000d')} style={{backgroundColor:color_devoir[devoir.classe]}} >
              <div className="info_mess">{devoir.donne_le}<br/>{!devoir.date_limit.includes('0000') ? <span className="date_limit_arrow">{cleanDate(devoir.date_limit)}</span>:''}</div>
              {devoir.facultatif === '1' ? <div className="facultatif_mark" title="Devoir optionnel"></div> : ''}
              {devoir.listeChoix ? <div className="choisi_mark" title="Devoir dont les questions sont choisies"></div> : ''}
              <div name="suppr_devoir" id={devoir.id} className="suppr_serie" onClick={handleSubmit} title="La suppression de la demande de faire ce devoir ne supprimera pas les résultats de ce devoir."></div>
              <div className="note_serie">{devoir.classe}</div> <div className="nb_question">{devoir.listeChoix ? devoir.listeChoix.split('_').length : devoir.nb_question}Q</div> {devoir.etoile === '4' ? <span style={{color:"steelblue", fontWeight:"bold"}} >🅳</span> : '⭐'.repeat(devoir.etoile)}
              <div>{devoir.title || devoir.activite.split('__')[0] + (devoir.activite.split('__')[1] ? '...' : '')}</div>
              {devoir.consigne && <div className="consigne">{devoir.consigne}</div>}
              {user.activite_faites[devoir.classe][devoir.activite] ? 
                <span>
                  <span className="green">{user.activite_faites[devoir.classe][devoir.activite]?.length}/{user.mes_classes[devoir.classe]?.length}</span> - <span className={color_note(moyenne(user.activite_faites[devoir.classe][devoir.activite]))}>{moyenne(user.activite_faites[devoir.classe][devoir.activite])}%</span>
                </span>:''
              }
            </div>
          )}
        </div>
      </div>


      <div className="content" style={{textAlign:"left", minHeight:'150px'}} >
        <h1>Différenciation des {devoir_cree.classe}</h1>
        <div name="info_diff" style={{fontSize:'1.5em', cursor:'pointer', position:'absolute', top:'30px', right:'30px'}} onClick={handleClick}>ℹ️</div>
        {devoir_cree.info_diff &&
          <div style={{border:'2px solid rgba(0,0,255,0.2)', backgroundColor:'rgba(0,0,255,0.07)', borderRadius:'10px', padding:'10px 15px'}}>
            Dans cette partie, vous pouvez affiner votre évaluation par différenciation.<br/>
            Pour cela, il suffit de cliquer sur le prénom d'un élève pour le basculer automatiquement sur le niveau suivant.<br/>
            Lorsque vous créerez un devoir, il suffira de selectionner le niveau de difficulté <span style={{color: 'steelblue', fontWight: 'bold'}}>🅳</span> pour que le programme s'occupe d'attribuer le niveau correspondant à votre choix pour chaque élève.<br/>
            ⚠️ Ne pas oublier de cliquer sur le bouton "Mettre à jour".
          </div>
        }

        <div style={{display:'flex', justifyContent:'space-around', marginBottom:'10px', fontSize:'1.2em'}}>
          <span className="teal">
            <span className="diff_cadre">Niveaux 1 : <span style={{fontSize:'1.5em'}} >⭑</span></span>
            <div className="diff_cadre">
              {user.mes_classes[devoir_cree.classe]?.map(eleve => 
                diff_niv(eleve) === 'teal' && 
                <span key={eleve.id} id={eleve.id} name="diff_eleve" className={diff_niv(eleve)} title='Niveau 1 ' style={{cursor:"pointer"}} onClick={handleClick}>{eleve.prenom} <br/>
                </span>
              )}
            </div>
          </span> 

          <span className="chocolate">
            <span className="diff_cadre">Niveaux 2 : <span style={{fontSize:'1.5em'}} >⭑⭑</span></span>
            <div className="diff_cadre">
              {user.mes_classes[devoir_cree.classe]?.map(eleve => 
                diff_niv(eleve) === 'chocolate' && 
                <span key={eleve.id} id={eleve.id} name="diff_eleve" className={diff_niv(eleve)} title='Niveau 2 ' style={{cursor:"pointer"}} onClick={handleClick}>{eleve.prenom} <br/>
                </span>
              )}
            </div>
          </span>

          <span className="purple">
            <span className="diff_cadre">Niveaux 3 : <span style={{fontSize:'1.5em'}} >⭑⭑⭑</span></span>
            <div className="diff_cadre">
              {user.mes_classes[devoir_cree.classe]?.map(eleve => 
                diff_niv(eleve) === 'purple' && 
                <span key={eleve.id} id={eleve.id} name="diff_eleve" className={diff_niv(eleve)} title='Niveau 3 ' style={{cursor:"pointer"}} onClick={handleClick}>{eleve.prenom} <br/>
                </span>
              )}
            </div>
          </span>
        </div>

        {/*<div align="center" style={{columns:'2', fontSize:'1.2em'}} >
          {user.mes_classes[devoir_cree.classe]?.map(eleve => 
            <span key={eleve.id} id={eleve.id} name="diff_eleve" className={diff_niv(eleve)} title={diff_niv(eleve) == 'teal' ? 'Niveau 1 ' : (diff_niv(eleve) == 'chocolate' ? 'Niveau 2 ' : 'Niveau 3')} style={{cursor:"pointer"}} onClick={handleClick}>{eleve.prenom} <br/></span>
          )}
        </div>*/}
        <div align="center">
          {msg.diff_maj ? <span dangerouslySetInnerHTML={{ __html:msg.diff_maj}}></span> : ''}
          <input type="button" className="btn" name="diff_maj" onClick={handleSubmit} value="Mettre à jour" />
        </div>
      </div>
      </>
      : <>
          <br/><br/><br/><br/><br/>
          <div className="info"><br/> Veuillez d'abord créer une classe.<br/><br/></div>
        </>
      }
      {show_activite ? 
        <Modal auth={{...auth, profil:user.profil, notion:devoir_cree.notion, nb_question:devoir_cree.nb_question, etoile:devoir_cree.etoile ? devoir_cree.etoile.length : '0', activite:devoir_cree.notion.join('__'), niveau:devoir_cree.niveau}} setShow_activite={setShow_activite} />
          : ''}
    </div>
  );
}